import React, { useMemo, useState } from "react";
import { useAtom } from "jotai";
import { useQuery } from "@tanstack/react-query";
import { Divider, Grid, Icon, Menu, Table } from "semantic-ui-react";
import { userAtom } from "../atoms/authAtom";
import Title from "../components/Title.js";
import AdminOrderTableRow from "./AdminOrderTableRow.js";

import ErrorPage from "../ErrorPage.js";

const fetchAdminOrders = async () => {
  // const sortOrder = sortDirection === "ascending" ? "" : "-";
  const sortOrder = "-";
  const sortColumn = "id";
  const sortParam = `sort_by=${sortOrder}${sortColumn}`;

  const response = await fetch(`/api/orders?${sortParam}`);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

const AdminOrders = () => {
  const [user] = useAtom(userAtom);

  const sortColumn = "id";
  const sortDirection = "descending";
  const [shippedFilter, setShippedFilter] = useState(false);

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ["adminOrders"],
    queryFn: fetchAdminOrders,
  });

  const allOrders = useMemo(() => data?.orders || [], [data?.orders]);

  const orders = useMemo(() => {
    if (shippedFilter) {
      return allOrders.filter((order) => order.shipped);
    }

    return allOrders.filter((order) => !order.shipped && !order.payment_slug);
  }, [allOrders, shippedFilter]);

  const paymentWaitingOrders = useMemo(
    () => allOrders.filter((order) => !order.shipped && order.payment_slug),
    [allOrders],
  );

  if (!user?.admin) {
    return <ErrorPage />;
  }

  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error: {error.message}</p>;

  return (
    <div>
      <Grid>
        <Grid.Column width={8}>
          <Title title="Admin: Orders" />
        </Grid.Column>
        <Grid.Column width={8} textAlign="right">
          <Menu compact icon>
            <Menu.Item
              name="dolly"
              active={!shippedFilter}
              onClick={() => {
                setShippedFilter(false);
              }}
            >
              <Icon name="dolly" />
            </Menu.Item>
            <Menu.Item
              name="shipping fast"
              active={shippedFilter}
              onClick={() => {
                setShippedFilter(true);
              }}
            >
              <Icon name="shipping fast" />
            </Menu.Item>
            <Menu.Item
              name="refresh"
              onClick={() => {
                refetch();
              }}
            >
              <Icon name="refresh" loading={isFetching} />
            </Menu.Item>
          </Menu>
        </Grid.Column>
      </Grid>
      <Table celled stackable striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              sorted={sortColumn === "id" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('id');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              ID
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "created_at" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('created_at');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Date
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "customer.name" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('customer.name');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Customer
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "total" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('total');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Total
            </Table.HeaderCell>
            <Table.HeaderCell
              collapsing
              sorted={sortColumn === "paid" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('paid');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Paid
            </Table.HeaderCell>
            <Table.HeaderCell
              collapsing
              sorted={sortColumn === "shipment_method.name" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('shipment_method.name');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Shipment Method
            </Table.HeaderCell>
            <Table.HeaderCell
              collapsing
              sorted={sortColumn === "shipped" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('shipped');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Shipped
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {orders.map((order) => (
            <AdminOrderTableRow key={order.id} order={order} />
          ))}
        </Table.Body>
      </Table>

      <Divider />
      <Title title="Admin: Payment Waiting" />

      <Table celled stackable striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              sorted={sortColumn === "id" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('id');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              ID
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "created_at" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('created_at');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Date
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "customer.name" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('customer.name');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Customer
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={sortColumn === "total" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('total');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Total
            </Table.HeaderCell>
            <Table.HeaderCell
              collapsing
              sorted={sortColumn === "paid" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('paid');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Paid
            </Table.HeaderCell>
            <Table.HeaderCell
              collapsing
              sorted={sortColumn === "shipment_method.name" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('shipment_method.name');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Shipment Method
            </Table.HeaderCell>
            <Table.HeaderCell
              collapsing
              sorted={sortColumn === "shipped" ? sortDirection : null}
              // onClick={() => {
              //   setSortColumn('shipped');
              //   setSortDirection(sortDirection === 'ascending' ? 'descending' : 'ascending');
              // }}
            >
              Shipped
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {paymentWaitingOrders.map((order) => (
            <AdminOrderTableRow key={order.id} order={order} />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default React.memo(AdminOrders);
